"use client";
import React, { ReactNode } from "react";

interface SectionProps {
  title?: string;
  children: ReactNode;
  className?: string;
  btns?: ReactNode;
  redStare?: boolean;
  [key: string]: any;
}

const Section: React.FC<SectionProps> = ({
  title,
  children,
  className,
  btns,
  redStare = false,
  ...props
}) => (
  <div className={`w-full flex flex-col gap-2 ${className}`} {...props}>
    <div className="flex justify-between items-end min-h-[40px] gap-2 flex-wrap">
      {title && (
        <div className="text-right text-[#141522] text-base font-medium">
          {title}
          {redStare && <span className="text-red-500 px-2 text-[18px]">*</span>}
        </div>
      )}
      {btns && <div className="flex gap-2">{btns}</div>}
    </div>
    {children}
  </div>
);

export default Section;
